/**
 * 任务操作日志 API 调用层
 */
import apiClient from '@/utils/apiClient';
import type {
  TaskOperationLog,
  TaskOperationLogQueryParams,
} from '@/types/task-operation-log';

/**
 * 查询任务操作日志列表
 */
export async function getTaskOperationLogs(
  taskId: string,
  params?: TaskOperationLogQueryParams
): Promise<{ data: TaskOperationLog[]; total: number }> {
  const searchParams = new URLSearchParams();

  if (params?.operationType) {
    searchParams.append('operation_type', params.operationType);
  }
  if (params?.keyword) {
    searchParams.append('keyword', params.keyword);
  }
  if (params?.current) {
    searchParams.append('current', params.current.toString());
  }
  if (params?.pageSize !== undefined) {
    searchParams.append('pageSize', params.pageSize.toString());
  }

  const response = (await apiClient.get(
    `/tasks/${taskId}/operation-logs?${searchParams.toString()}`
  )) as unknown as {
    success: boolean;
    data: TaskOperationLog[];
    total: number;
  };

  if (!response.success) {
    console.warn('获取操作日志失败:', response);
    return {
      data: [],
      total: 0,
    };
  }

  return {
    data: Array.isArray(response.data) ? response.data : [],
    total: response.total || 0,
  };
}

/**
 * 格式化操作日志时间显示
 * 当年：MM月DD日 HH:mm
 * 跨年：YYYY年MM月DD日 HH:mm
 */
export function formatLogTime(createdAt: string): string {
  const date = new Date(createdAt);
  const now = new Date();
  const isCurrentYear = date.getFullYear() === now.getFullYear();

  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  if (isCurrentYear) {
    return `${month}月${day}日 ${hours}:${minutes}`;
  } else {
    const year = date.getFullYear();
    return `${year}年${month}月${day}日 ${hours}:${minutes}`;
  }
}
